/**
 * SideNav control instance
 */

export class SideNavControl {
    constructor(
        public title: string,
        public icon: string,
        public link: string[]
    ){ }
}